export default "__VITE_ASSET__8899bca6__"